import { render, staticRenderFns } from "./officerRecipients.vue?vue&type=template&id=2fdc337e&scoped=true"
import script from "./officerRecipients.vue?vue&type=script&lang=js"
export * from "./officerRecipients.vue?vue&type=script&lang=js"
import style0 from "./officerRecipients.vue?vue&type=style&index=0&id=2fdc337e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc337e",
  null
  
)

export default component.exports